var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { 'pb-alert': true }, _obj[_vm.latlng] = true, _obj )},_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:alert.uid,class:("pb-alert-item " + (alert.type)),style:(_vm.stylus(index))},[_c('pb-float',{attrs:{"float":"left"}},[_vm._v("\n      "+_vm._s(alert.content)+"\n    ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }